import Dashboard from "views/Dashboard/Dashboard.jsx";
import Bills from "views/Bills/BillsGlobalStatus.jsx";
import MobilesList from "views/Mobiles/MobilesList.jsx";
import Buttons from "views/Components/Buttons.jsx";
import Customers from "views/Customers/CustomersList.jsx";
import GridSystem from "views/Components/GridSystem.jsx";
import Panels from "views/Components/Panels.jsx";
import SweetAlert from "views/Components/SweetAlertPage.jsx";
import Notifications from "views/Components/Notifications.jsx";
import Icons from "views/Components/Icons.jsx";
import Typography from "views/Components/Typography.jsx";
import ContractsList from "views/Contracts/ContractsList.jsx";
import RegularForms from "views/Forms/RegularForms.jsx";
import ExtendedForms from "views/Forms/ExtendedForms.jsx";
import ValidationForms from "views/Forms/ValidationForms.jsx";
import Wizard from "views/Forms/Wizard/Wizard.jsx";
import RegularTables from "views/Tables/RegularTables.jsx";
import ExtendedTables from "views/Tables/ExtendedTables.jsx";
import ReactTable from "views/Tables/ReactTable.jsx";
import GoogleMaps from "views/Maps/GoogleMaps.jsx";
import FullScreenMap from "views/Maps/FullScreenMap.jsx";
import VectorMap from "views/Maps/VectorMap.jsx";
import Charts from "views/Charts/Charts.jsx";
import Calendar from "views/Calendar/Calendar.jsx";
import Calendar_back from "views/Calendar/Calendar_back.jsx";
import Widgets from "views/Widgets/Widgets.jsx";
import UserPage from "views/Pages/UserPage.jsx";
import TimelinePage from "views/Pages/TimelinePage.jsx";
import RTL from "views/Pages/RTL.jsx";
import Pegasus from "views/Pegasus/Pegasus.jsx";
import Cajas from "views/CashRegisters/CashRegistersList.jsx";
import Tools from "views/Tools/Tools.jsx";
import Tickets from "views/Tickets/Tickets.jsx";
import Coverage from "views/Coverage/Coverage.jsx";
import MobileWebRequestList from "views/Web/MobileWebRequestList.jsx";
import WebContent from "views/Web/WebContent.jsx";
import Roulette from "views/Roulette/Roulette.jsx";

import pagesRoutes from "./pages.jsx";

var pages = [
  {
    path: "/timeline-page",
    name: "Timeline Page",
    mini: "TP",
    component: TimelinePage
  },
  { path: "/user-page", name: "User Profile", mini: "UP", component: UserPage },
  { path: "/rtl-support", name: "RTL Support", mini: "RS", component: RTL }
].concat(pagesRoutes);

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "shopping_shop",
    component: Dashboard
  },
  // {
  //   path: "/cobertura",
  //   name: "Cobertura",
  //   icon: "location_compass-05",
  //   component: Coverage
  // },
  // {
  //   path: "/citas",
  //   name: "Citas",
  //   icon: "ui-1_calendar-60",
  //   component: Dashboard
  // },
  // {
  //   path: "/calendario",
  //   name: "Calendario",
  //   icon: "ui-1_calendar-60",
  //   component: Calendar
  // },
  // {
  //   path: "/cajas",
  //   name: "Cajas",
  //   icon: "business_money-coins",
  //   component: Cajas
  // },
  // {
  //   path: "/pegasus",
  //   name: "Pegasus",
  //   icon: "objects_spaceship",
  //   component: Pegasus
  // },
  // {
  //   path: "/tramites",
  //   name: "Trámites",
  //   icon: "education_paper",
  //   component: Dashboard
  // },
  // {
  //   path: "/ruleta",
  //   name: "Ruleta",
  //   icon: "business_chart-pie-36",
  //   component: Roulette
  // },
  // {
  //   collapse: true,
  //   path: "/pages",
  //   name: "Web",
  //   state: "openWeb",
  //   icon: "business_globe",
  //   views: [
  //     {
  //       path: "/web/solicitudes-movil",
  //       name: "Solicitudes móvil",
  //       mini: "SM",
  //       component: MobileWebRequestList
  //     },
  //     {
  //       path: "/web",
  //       name: "Formularios web",
  //       mini: "FW",
  //       component: WebContent
  //     }
  //   ]
  // },
  // {
  //   path: "/facturas",
  //   name: "Facturas",
  //   icon: "files_single-copy-04",
  //   component: Bills
  // },
  // {
  //   path: "/movil",
  //   name: "Móvil",
  //   icon: "tech_mobile",
  //   component: MobilesList
  // },
  // {
  //   path: "/clientes",
  //   name: "Clientes",
  //   icon: "users_single-02",
  //   component: Customers
  // },
  // {
  //   path: "/contratos",
  //   name: "Contratos",
  //   icon: "files_paper",
  //   component: ContractsList
  // },
  // {
  //   path: "/herramientas",
  //   name: "Herramientas",
  //   icon: "ui-2_settings-90",
  //   component: Tools
  // },
  // {
  //   path: "/tickets",
  //   name: "Tickets",
  //   icon: "shopping_tag-content",
  //   component: Tickets
  // },
  // {
  //   collapse: true,
  //   path: "/pages",
  //   name: "Pages",
  //   state: "openPages",
  //   icon: "design_image",
  //   views: pages
  // },
  // {
  //   collapse: true,
  //   path: "/components",
  //   name: "Components",
  //   state: "openComponents",
  //   icon: "education_atom",
  //   views: [
  //     {
  //       path: "/components/buttons",
  //       name: "Buttons",
  //       mini: "B",
  //       component: Buttons
  //     },
  //     {
  //       path: "/components/grid-system",
  //       name: "Grid System",
  //       mini: "GS",
  //       component: GridSystem
  //     },
  //     {
  //       path: "/components/panels",
  //       name: "Panels",
  //       mini: "P",
  //       component: Panels
  //     },
  //     {
  //       path: "/components/sweet-alert",
  //       name: "Sweet Alert",
  //       mini: "SA",
  //       component: SweetAlert
  //     },
  //     {
  //       path: "/components/notifications",
  //       name: "Notifications",
  //       mini: "N",
  //       component: Notifications
  //     },
  //     { path: "/components/icons", name: "Icons", mini: "I", component: Icons },
  //     {
  //       path: "/components/typography",
  //       name: "Typography",
  //       mini: "T",
  //       component: Typography
  //     }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/forms",
  //   name: "Forms",
  //   state: "openForms",
  //   icon: "design_bullet-list-67",
  //   views: [
  //     {
  //       path: "/forms/regular-forms",
  //       name: "Regular Forms",
  //       mini: "RF",
  //       component: RegularForms
  //     },
  //     {
  //       path: "/forms/extended-forms",
  //       name: "Extended Forms",
  //       mini: "EF",
  //       component: ExtendedForms
  //     },
  //     {
  //       path: "/forms/validation-forms",
  //       name: "Validation Forms",
  //       mini: "VF",
  //       component: ValidationForms
  //     },
  //     { path: "/forms/wizard", name: "Wizard", mini: "W", component: Wizard }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/tables",
  //   name: "Tables",
  //   state: "openTables",
  //   icon: "files_single-copy-04",
  //   views: [
  //     {
  //       path: "/tables/regular-tables",
  //       name: "Regular Tables",
  //       mini: "RT",
  //       component: RegularTables
  //     },
  //     {
  //       path: "/tables/extended-tables",
  //       name: "Extended Tables",
  //       mini: "ET",
  //       component: ExtendedTables
  //     },
  //     {
  //       path: "/tables/react-table",
  //       name: "React Table",
  //       mini: "RT",
  //       component: ReactTable
  //     }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/maps",
  //   name: "Maps",
  //   state: "openMaps",
  //   icon: "location_pin",
  //   views: [
  //     {
  //       path: "/maps/google-maps",
  //       name: "Google Maps",
  //       mini: "GM",
  //       component: GoogleMaps
  //     },
  //     {
  //       path: "/maps/full-screen-maps",
  //       name: "Full Screen Map",
  //       mini: "FSM",
  //       component: FullScreenMap
  //     },
  //     {
  //       path: "/maps/vector-maps",
  //       name: "Vector Map",
  //       mini: "VM",
  //       component: VectorMap
  //     }
  //   ]
  // },
  // {
  //   path: "/widgets",
  //   name: "Widgets",
  //   icon: "objects_diamond",
  //   component: Widgets
  // },
  // {
  //   path: "/charts",
  //   name: "Charts",
  //   icon: "business_chart-pie-36",
  //   component: Charts
  // },
  // {
  //   path: "/calendar",
  //   name: "Calendar",
  //   icon: "media-1_album",
  //   component: Calendar_back
  // },
  { redirect: true, path: "/", pathTo: "/dashboard", name: "Dashboard" }
];
export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx